// extracted by mini-css-extract-plugin
export var copyIcon = "_ym-2";
export var discountCard = "_ym-0";
export var discountCode = "_ym-3";
export var discountContent = "_ym-1";
export var loadingCard = "_ym-4";